<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="tvandroid"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Master Room Edit
                    </span>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
          
          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-card-text>
                  <ValidationObserver 
                    ref="form">
                    <v-form>
                      <v-row>
                        <v-col
                          cols="12"
                          md="4">
                          <ValidationProvider 
                            name="Number" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Number
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              
                              :color="set_color"
                              placeholder="Ex : B01"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                              v-model="form.number"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>

                          <ValidationProvider 
                            name="Password" 
                            rules="required|min:5|max:20" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Password
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :type="show ? 'text' : 'password'"
                              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                              @click:append="show = !show"
                              :counter="20"

                              :color="set_color"
                              placeholder="Ex : ******"

                              v-model="form.password"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="4">
                          <ValidationProvider 
                            name="Room Type" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Room Type
                            </div>

                            <v-select
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              
                              :color="set_color"
                              placeholder="Ex : Reguler"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"
                              
                              :items="category"
                              item-text="name"
                              item-value="id"
                              :item-color="set_color"
                              
                              clearable
                              @click:clear="form.category_id = ''"
                              
                              v-model="form.category_id"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-select>
                          </ValidationProvider>

                          <ValidationProvider 
                            name="Type" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Type
                            </div>

                            <v-select
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              
                              :color="set_color"
                              placeholder="Ex : Room"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"
                              
                              :items="[
                                {
                                  text: 'Room',
                                  value: 'room'
                                },
                                {
                                  text: 'TV Only',
                                  value: 'tv_only'
                                },
                                {
                                  text: 'Public Space',
                                  value: 'public'
                                }
                              ]"
                              item-text="text"
                              item-value="value"
                              :item-color="set_color"
                              
                              clearable
                              @click:clear="form.type = ''; form.layout_id = 0;"

                              @change="form.layout_id = 0"
                              
                              v-model="form.type"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-select>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="4">
                          <ValidationProvider 
                            name="Floor" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Floor
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                              type="number"
                              min="0"

                              @focus="$event.target.select()"

                              :color="set_color"
                              placeholder="Ex : 1"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"

                              v-model="form.floor"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>

                          <ValidationProvider  v-if="form.type === 'public'"
                            name="Public Space" 
                            rules="required" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              <span class="red--text">*</span>

                              Public Space
                            </div>

                            <v-select
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              
                              :color="set_color"
                              placeholder="Ex : Image Slider"
                              :append-icon="valid ? 'mdi-check-circle-outline' : ''"
                              
                              :items="public_space"
                              item-text="name"
                              item-value="id"
                              :item-color="set_color"
                              
                              clearable
                              @click:clear="form.layout_id = 0"
                              
                              v-model="form.layout_id"
                              :success="valid"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-select>
                          </ValidationProvider>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                          class="py-0">
                          <div
                            class="body-2 font-weight-bold black--text">
                            #Cast Room
                          </div>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          md="4"
                          class="pb-0">
                          <ValidationProvider 
                            name="WIFI - SSID/Network Name" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              WIFI - SSID/Network Name
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense
                              
                              :color="set_color"
                              placeholder="Ex : Visuality"
                              :append-icon="valid && form.cast_ssid !== '' ? 'mdi-check-circle-outline' : ''"

                              v-model="form.cast_ssid"
                              :success="valid && form.cast_ssid !== ''"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="4"
                          class="pb-0">
                          <ValidationProvider 
                            name="WIFI - Security" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              WIFI - Security
                            </div>

                            <v-select
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :color="set_color"
                              placeholder="Ex : ******"
                              :append-icon="valid && form.cast_security !== '' ? 'mdi-check-circle-outline' : ''"

                              :items="[
                                {
                                  text: 'WPA',
                                  value: 'WPA'
                                },
                                {
                                  text: 'WPA2',
                                  value: 'WPA2'
                                },
                                {
                                  text: 'WEP',
                                  value: 'WEP'
                                },
                                {
                                  text: 'Nopass',
                                  value: 'nopass'
                                }
                              ]"
                              item-text="text"
                              item-value="value"
                              :item-color="set_color"
                              
                              clearable
                              @click:clear="form.cast_security = ''"

                              v-model="form.cast_security"
                              :success="valid && form.cast_security !== ''"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-select>
                          </ValidationProvider>
                        </v-col>

                        <v-col
                          cols="12"
                          md="4"
                          class="pb-0">
                          <ValidationProvider 
                            name="Password" 
                            rules="min:5|max:20" 
                            v-slot="{ errors, valid }">
                            <div class="body-2 mb-2">
                              Password
                            </div>

                            <v-text-field
                              v-on:keyup.enter="save()"
                              
                              filled
                              rounded
                              dense

                              :type="show ? 'text' : 'password'"
                              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                              @click:append="show = !show"
                              :counter="20"

                              :color="set_color"
                              placeholder="Ex : ******"

                              v-model="form.cast_password"
                              :success="valid && form.cast_password !== ''"
                              :error-messages="errors"
                              required
                              style="border-radius: 10px;">
                            </v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                    </v-form>
                  </ValidationObserver>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="2"
              class="py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                block
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize"
                style="border-radius: 8px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                Save
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        show: false,

        category: [],
        public_space: [],

        form: {
          id: '',
          number: '',
          password: '',
          floor: '',
          category_id: '',
          type: '',
          layout_id: 0,

          cast_ssid: '',
          cast_password: '',
          cast_security: ''
        },

        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        let params = {
          id: this.$route.params.id
        }

        await get(`admin/master-room/detail`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.code === 200) {
            this.form = res.result

            this.form.password = res.result.password_visible

            this.fetchCategory()

            this.fetchPublicSpace()
          }
        })
      },

      async fetchCategory () {
        let params = {
          limit: 100000
        }

        await get(`admin/room-category/data`, { params })
        .then(response => {
          let res = response.data

          if (res.code === 200) {
            this.category = res.result.data
          }
        })
      },

      async fetchPublicSpace () {
        let params = {
          limit: 100000
        }

        await get(`admin/public-layout/data`, { params })
        .then(response => {
          let res = response.data

          if (res.code === 200) {
            this.public_space = res.result.data
          }
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/master-room/update`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.code === 200) {
              this.$router.push('/setting/master')
            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>